import React from "react";
import "./empheader.css";
import Creatable from "react-select/creatable";
import { FaSearch } from "react-icons/fa";


const options = [
    { value: "Employee ID", label: "Employee ID"},
    { value: "Employee Name", label: "Employee Name" },
    { value: "Mobile Number", label: "Mobile Number" }
  ]

function EmpHeader (item) {
    return(
        <div className="container mainempheader">
            <div className="row empheader">
                <div className="col-7 empheadertitle">{item.emptitle}</div>
                <div className="col-5 empsearch">
                <span className="searchicon" ><FaSearch /></span>
                <Creatable options={options} className="epmsearchoptionbox" defaultValue={options[0]} />
                </div>
            </div>
        </div>
    )
};

export default EmpHeader ;